import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { AuthenticationService } from "../../services/authentication/authentication.service";
import { LayoutService } from "../../services/layouts/layout.service";
import { Translator } from "@sharedV11/services/translator/translator.service";
import { userResponse } from "../../classes/userResponse/user-response";

interface NavigateElemente {
  targetRoute: string;
  childNameKeyTranslate: string;
  parentLabels: string[];
  traduccionesEntry: TraductionEntry;
  defaultParentMenuElement: DefaultParentMenuElment
}

interface TraductionEntry {
  id: string;
  texto: string;
  icono: string;
  route: string;
}
interface DefaultParentMenuElment {
  id: string;
  texto: string;
  icono: string;
  submenu: TraductionEntry[];
}


@Component({
  selector: "app-sidemenu",
  templateUrl: "./sidemenu.component.html",
  styleUrls: ["./sidemenu.component.scss"],
})
export class SidemenuComponent implements OnInit {
  menuDevelopment: any = [];
  logueado: boolean;
  Botones;
  Version: string;
  events: string[] = [];
  opened: boolean;
  modelo = [];
  submenuTitulo = "";
  layoutservices: LayoutService;
  translateData: any;

  parentLabelsOfConfiguracionProyecto = [
      "CONFIGURACIÓN DEL PROYECTO",
      "CONFIGURACION DEL PROYECTO",
      "CONFIGURACIÓN",
      "CONFIGURACION",
    ];

  constructor(
    private autentificador: AuthenticationService,
    private router: Router,
    private _ruta: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private _layoutservices: LayoutService,
    private translator: Translator
  ) {
    this.layoutservices = _layoutservices;
  }

  ngOnInit(): void {

    this.translateData = this.translator.GetTranslations();

    if (!environment.production) {
      this.initializeDataListDevelopment();
    }

    // this.Version = environment.version;
    this.logueado = !this.autentificador.ocultarMenusQueryString(this._ruta);
    if (this.logueado) {
      this.Botones = this.autentificador.getPermisosComoBotones();
      this.injectAccessControlKuroiMenu();
      this.ensureTraduccionesMenuEntry();
      
      this.insertImpresionOnlineChildMenuElement();
      // console.log('botones', this.Botones);
      // if (this.Botones.length === 0) {
      //   //this.router.navigate(['login']);
      // } else {
      // }
    }

    this.layoutservices.urlclicked.subscribe((u) => {
      if (u && u !== undefined) this.clicksubmenu(u);
    });
  }

  private injectAccessControlKuroiMenu(): void {
    if (!this.Botones || !Array.isArray(this.Botones)) {
      return;
    }

    const maestrosSection = this.Botones.find((item) => {
      if (!Array.isArray(item?.submenu)) {
        return false;
      }
      const hasMaestrosRoute = item.submenu.some((submenuItem) =>
        (submenuItem?.route ?? "").toLowerCase().startsWith("/maestros/")
      );
      const isMaestrosLabel =
        item?.texto?.toLowerCase?.() === "maestros" ||
        item?.texto?.toLowerCase?.() ===
          (this.translateData?.Maestros?.toLowerCase?.() ?? "");
      return hasMaestrosRoute || isMaestrosLabel;
    });

    if (!maestrosSection || !Array.isArray(maestrosSection.submenu)) {
      return;
    }

    const alreadyExists = maestrosSection.submenu.some(
      (submenuItem) =>
        submenuItem?.route?.toLowerCase() ===
        "/maestros/controlaccesoskuroi".toLowerCase()
    );

    if (!alreadyExists) {
      maestrosSection.submenu.push({
        texto:
          this.translateData?.ControlAccesos ?? this.translateData?.ControlAccesosKuroi ?? "Control Accesos",
        route: "/Maestros/ControlAccesos",
      });
    }
  }

  async initializeTranslate() {
    let lang = this.translator.getLocale() || "es-ES";
    this.translateData = this.translator.GetTranslations();

    if (!localStorage.getItem("Language")) {
      localStorage.setItem("Language", lang);
    }
    if (localStorage.getItem("Language")) {
      lang = localStorage.getItem("Language");
    }

    this.translator.setLocale(lang);
    await this.translator.use(lang).then((data) => {
      if (data) {
        this.translateData = data;
      }
    });
  }

  initializeDataListDevelopment() {
    this.menuDevelopment = [
      {
        name: "Espacios",
        subMenu: [
          { name: "Espectáculos", route: "/Recintos/Espectaculos" },
          {
            name: "Sesiones con Butacas",
            route: "/Recintos/SesionesConButaca",
          },
        ],
      },
      {
        name: "Codigos Promocionales",
        subMenu: [
          {
            name: "CodigoPromocional",
            route: "/CodigosPromocionales/CodigoPromocional",
          },
          {
            name: "TipoCodigoPromocional",
            route: "/CodigosPromocionales/TipoCodigoPromocional",
          },
          {
            name: "CodigoPromocionalBines",
            route: "/CodigosPromocionales/CodigoPromocionalBines",
          }
        ],
      } /*
      {"name":"Clientes V11","subMenu":[
        {"name":"Cliente V11","route":"/Clientes/ClienteV11"},
        {"name":"Client Group V11","route":"/Clientes/GrupoClienteV11"},
        {"name":"Formas de Pago V11","route":"/Clientes/FormasPagoV11"}


      ]},
      {"name":"Maestros V11","subMenu":[
        {"name":"Type access control  V11","route":"/Maestros/TypeAccessControlV11"}

      ]},*/,
      {
        name: "Tarifas",
        subMenu: [
          {
            name: "Tipo Reserva",
            route: "/Tarifas/TipoReserva"
          },
          {
            name: "Grupos Tarifas",
            route: "/Tarifas/GruposTarifas"
          }
        ],
      },
      {
        name: "Tienda",
        subMenu: [
          {
            name: "Proveedores",
            route: "/tienda/Proveedores"
          },
          {
            name: "Productos",
            route: "/tienda/ProductosTienda"
          },
          {
            name: "Productos Promociones",
            route: "/tienda/ProductosPromociones"
          },
          {
            name: "Gestión de Inventario",
            route: "/tienda/gestioninventario"
          },
        ],
      },
      {
        name: 'Entradas y Promociones',
        subMenu: [
          {
            name: 'Reglas de negocio',
            route: '/EntradasPromociones/ReglasNegocio'
          }
        ]
      },
      {
        name: 'Maestros',
        subMenu: [
          {
            name: 'Jerarquía de Categorias',
            route: '/Maestros/CategoriasJerarquicas'
          },
          {
            name: 'Schemas',
            route: '/Maestros/schemas'
          },
        ]
      }
    ];
  }

  clicksubmenu(ruta) {
    var allRoutes: string[] = [];

    for (var i = 0; i < this.router.config.length; i++) {
      allRoutes.push(this.router.config[i].path);
    }
    for (var i = 0; i < this.router.config[0].children.length; i++) {
      allRoutes.push(this.router.config[0].children[i].path);
      if (this.router.config[0].children[i].children) {
        for (
          var j = 0;
          j < this.router.config[0].children[i].children.length;
          j++
        ) {
          allRoutes.push(
            this.router.config[0].children[i].path +
              "/" +
              this.router.config[0].children[i].children[j].path
          );
        }
      }
    }

    if (allRoutes.find((x) => "/" + x == ruta)) {
      this.router.navigate([ruta]);
    } else {
      this.openSnackBar(this.translateData["Nodisponible"], this.translateData["Aceptar"]);
    }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2500,
      panelClass: ["blue-snackbar"],
      horizontalPosition: "center",
      verticalPosition: "top",
    });
  }

  /**
   * Busca o nome do módulo nas permissões originais da API
   * @param moduloId ID do módulo
   * @returns Nome do módulo (NombreModuloIdioma) ou NombreModulo como fallback, ou null
   */
  private getNombreModuloFromAPI(moduloId: number | string): string | null {
    try {
      if (sessionStorage.getItem("currentUser") != null) {
        const userResp = new userResponse();
        const permisos = userResp.deserialize(
          JSON.parse(sessionStorage.getItem("currentUser"))
        ).DatosResult.Permisos;
        const modulo = permisos.find(
          (p) => p.ModuloId == moduloId && p.NombreAccion.trim().toUpperCase() == "VER"
        );
        if (modulo) {
          return modulo.NombreModuloIdioma && modulo.NombreModuloIdioma.trim() !== "" 
            ? modulo.NombreModuloIdioma 
            : modulo.NombreModulo || null;
        }
      }
    } catch (error) {
      // Silenciosamente retorna null em caso de erro
    }
    return null;
  }

  /**
   * Busca o nome do submenu nas permissões originais da API baseado na rota
   * @param route Rota do submenu
   * @returns Nome do módulo (NombreModuloIdioma) ou NombreModulo como fallback, ou null
   */
  private getNombreSubmenuFromAPI(route: string): string | null {
    try {
      if (sessionStorage.getItem("currentUser") != null) {
        const userResp = new userResponse();
        const permisos = userResp.deserialize(
          JSON.parse(sessionStorage.getItem("currentUser"))
        ).DatosResult.Permisos;
        const modulo = permisos.find(
          (p) => p.Ventana && p.Ventana.trim().toLowerCase() === route.trim().toLowerCase() && 
                 p.NombreAccion.trim().toUpperCase() == "VER"
        );
        if (modulo) {
          return modulo.NombreModuloIdioma && modulo.NombreModuloIdioma.trim() !== "" 
            ? modulo.NombreModuloIdioma 
            : modulo.NombreModulo || null;
        }
      }
    } catch (error) {
      // Silenciosamente retorna null em caso de erro
    }
    return null;
  }

  /**
   * Verifica se o usuário tem permissão VER para uma rota específica
   * @param route Rota a verificar
   * @returns true se o usuário tem permissão VER, false caso contrário
   */
  private hasPermissionForRoute(route: string): boolean {
    try {
      if (sessionStorage.getItem("currentUser") != null) {
        const userResp = new userResponse();
        const permisos = userResp.deserialize(
          JSON.parse(sessionStorage.getItem("currentUser"))
        ).DatosResult.Permisos;
        const modulo = permisos.find(
          (p) => p.Ventana && p.Ventana.trim().toLowerCase() === route.trim().toLowerCase() && 
                 p.NombreAccion.trim().toUpperCase() == "VER"
        );
        return modulo != null;
      }
    } catch (error) {
      // Silenciosamente retorna false em caso de erro
    }
    return false;
  }

  private ensureTraduccionesMenuEntry(): void {
    if (!this.Botones || !Array.isArray(this.Botones)) {
      return;
    }

    const targetRoute = "/configuracion/traducciones";
    
    // Verificar se o usuário tem permissão VER para esta rota
    if (!this.hasPermissionForRoute(targetRoute)) {
      return;
    }
    
    // Buscar o nome da API - usar exatamente o que vem da API
    const nombreAPI = this.getNombreSubmenuFromAPI(targetRoute);
    const textoFinal = nombreAPI || "";

    this.Botones.forEach((menu) => {
      if (Array.isArray(menu?.submenu)) {
        menu.submenu.forEach((submenu) => {
          if (submenu.route === targetRoute) {
            if (nombreAPI) {
              submenu.texto = nombreAPI;
            }
          }
        });
      }
    });

  
    const menuExists = this.Botones.some((menu) => {
      if (!Array.isArray(menu?.submenu)) {
        return false;
      }
      return menu.submenu.some((submenu) => submenu.route === targetRoute);
    });

    if (menuExists) {
      return;
    }

    // Buscar o menu pai (ModuloId: 223 - CONFIGURACION)
    const nombreModuloPai = this.getNombreModuloFromAPI(223);
    const parentLabels = [
      "CONFIGURACIÓN DEL PROYECTO",
      "CONFIGURACION DEL PROYECTO",
      "CONFIGURACIÓN",
      "CONFIGURACION",
    ];
    const parentMenu = this.Botones.find(
      (menu) => parentLabels.indexOf((menu?.texto || "").toUpperCase()) !== -1 ||
                (nombreModuloPai && menu?.texto && menu.texto.trim().toUpperCase() === nombreModuloPai.trim().toUpperCase())
    );

    const traduccionesEntry = {
      id: "configuracion-traducciones",
      texto: textoFinal,
      icono: "translate",
      route: targetRoute,
    };

    if (parentMenu) {
      const alreadyExists =
        parentMenu.submenu &&
        parentMenu.submenu.some((submenu) => submenu.route === targetRoute);

      if (!alreadyExists) {
        parentMenu.submenu = [...(parentMenu.submenu || []), traduccionesEntry];
      }
    } else {
      const textoMenuPai = nombreModuloPai || "CONFIGURACION";
      this.Botones.push({
        id: "configuracion-del-proyecto",
        texto: textoMenuPai,
        icono: "settings",
        submenu: [traduccionesEntry],
      });
    }
  }

  private insertParentMenuWithChild(entryData: NavigateElemente): void {
    if (!this.Botones || !Array.isArray(this.Botones)) {
      return;
    }

    const targetRoute = entryData.targetRoute;
    const parentLabels = entryData.parentLabels;

    // Buscar o nome da API para o submenu
    const nombreAPI = this.getNombreSubmenuFromAPI(targetRoute);
    if (nombreAPI) {
      this.Botones.forEach((menu) => {
        if (Array.isArray(menu?.submenu)) {
          menu.submenu.forEach((submenu) => {
            if (submenu.route === targetRoute) {
              submenu.texto = nombreAPI;
            }
          });
        }
      });
    }

    // Buscar o menu pai pelo texto ou pelo ModuloId 223
    const nombreModuloPai = this.getNombreModuloFromAPI(223);
    const parentMenu = this.Botones.find(
      (menu) => parentLabels.indexOf((menu?.texto || "").toUpperCase()) !== -1 ||
                (nombreModuloPai && menu?.texto && menu.texto.trim().toUpperCase() === nombreModuloPai.trim().toUpperCase())
    );

    const traduccionesEntry = { ...entryData.traduccionesEntry };
    if (nombreAPI) {
      traduccionesEntry.texto = nombreAPI;
    }

    if (parentMenu) {
      // Atualizar o texto do menu pai se necessário
      if (nombreModuloPai && parentMenu.texto !== nombreModuloPai) {
        parentMenu.texto = nombreModuloPai;
      }

      const alreadyExists =
        parentMenu.submenu &&
        parentMenu.submenu.some((submenu) => submenu.route === targetRoute);

      if (!alreadyExists) {
        parentMenu.submenu = [...(parentMenu.submenu || []), traduccionesEntry];
      }
    } else {
      // Criar novo menu pai com o nome da API
      const textoMenuPai = nombreModuloPai || entryData.defaultParentMenuElement.texto;
      const newParentMenu = { ...entryData.defaultParentMenuElement };
      newParentMenu.texto = textoMenuPai;
      this.Botones.push(newParentMenu);
    }
  }

  private insertImpresionOnlineChildMenuElement(): void {
    const targetRoute = "/configuracion/ImpresionOnline";
    
    // Verificar se o usuário tem permissão VER para esta rota
    if (!this.hasPermissionForRoute(targetRoute)) {
      return;
    }
    
    // Buscar o nome da API - usar exatamente o que vem da API
    const nombreAPI = this.getNombreSubmenuFromAPI(targetRoute);
    const textoFinal = nombreAPI || "";

    // Buscar o menu pai (ModuloId: 223 - CONFIGURACION)
    const nombreModuloPai = this.getNombreModuloFromAPI(223);
    const textoMenuPai = nombreModuloPai || "CONFIGURACION";

    const parentLabels = [
      "CONFIGURACION DEL PROYECTO",
      "CONFIGURACIÓN DEL PROYECTO",
      "CONFIGURACION",
      "CONFIGURACIÓN",
    ];

    const traduccionesEntry = {
      id: "configuracion/ImpresionOnline",
      texto: textoFinal,
      icono: "settings",
      route: targetRoute,
    };

    const defaultParentMenuElement = {
      id: "configuracion",
      texto: textoMenuPai,
      icono: "settings",
      submenu: [traduccionesEntry],
    };

    this.insertParentMenuWithChild(
      {
        targetRoute,
        childNameKeyTranslate: textoFinal,
        parentLabels,
        traduccionesEntry,
        defaultParentMenuElement,
      }
    );
  }
}
